import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryItemFactory } from 'src/app/factories/inventory-item.factory';
import { InventoryService } from 'src/app/services/inventory.service';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';

@Component({
  selector: 'app-inventory-create',
  templateUrl: './inventory-create.component.html',
  styleUrls: ['./inventory-create.component.scss']
})
export class InventoryCreateComponent implements OnInit {

  public title = "";
  public types: any[] = [];

  constructor(
    private inventoryService: InventoryService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {

    this.route.params.subscribe(params => {

      if (params.type != undefined) {
        this.createItem(params.type);
      }
    });

    this.inventoryService.getItemTypes().subscribe((r: any) => {
      this.types = r;
    });
  }

  createItem(category: number) {
    this.inventoryService.create(InventoryItemFactory.new(category)).subscribe((item: InventoryItem)=> {
      this.router.navigate(["inventory", "view-item", item.number]);
    })
  }

}